import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";
import { theme } from "theme";
import { Icons, Ptag } from "..";

const BaseAccordian = ({ title, body, margin }) => {
  return (
    <Accordion
      TransitionProps={{
        timeout: 300,
      }}
      sx={{
        boxShadow: "none",
        border: "1px solid " + theme.primaryColor,
        marginBottom: "1rem",
        borderRadius: "4px",
      }}
    >
      <AccordionSummary expandIcon={<Icons icon="chevron_down" />}>
        <div style={{ margin: margin ? margin : "1rem 2rem" }}>
          <Ptag fontSize="16px" color="#7d7c7c">
            {title}
          </Ptag>
        </div>
      </AccordionSummary>
      <AccordionDetails>{body}</AccordionDetails>
    </Accordion>
  );
};

export default BaseAccordian;
